import React from 'react';
import { useNavigate } from 'react-router-dom';
import cardImg from '../images/cardIcon.png'
import '../step1.css';
import Home from './Home';
import Services from './Services';
import Contact from './Contact';
import HeroSection from './HeroSection';

const Step1 = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/step2');
  };

  return (
    <div className='container'>
        <HeroSection/>
        <Services/>
        <Home/>
        <Contact/>
        {/* <div className='wrapper_step1'>
          
        </div> */}
    </div>
  );
};

export default Step1;
